export default {
	urlApis(state){ return state.urlApis; },
	langTutor(state){ return state.langTutor; },
	accessApp(state){ return state.access; },
	get_asideStorage(state){ return state.asideStorage;},
	lateral(state) { return state.lateralShow; },
	selectedItem(state){ return state.selectedItem;},
	get_itemSalesAppointmente(state){ return state.itemSalesAppointmente;},
}
